import axios from "axios";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../helper";


const getToken = () => {
  const encryptedToken = localStorage.getItem('authToken');
  if (encryptedToken) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedToken, SECRET_KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Failed to decrypt token:", error);
      return null;
    }
  }
  return null;
};


const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    (typeof window !== "undefined" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1"
      ? "https://api.uo.edu.pk/api/"
      : "http://127.0.0.1:8001/api/"),
  timeout: 60000,
});

// Axios request interceptor to add the Bearer token to the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken(); // Retrieve token

    if (token) {
      // Attach token to the Authorization header if token exists
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle error globally if needed
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("authToken");
      // Redirect to login page
      window.location.href = "/signin";
      // or you can show a notification or redirect to login page here
      console.log("Unauthorized access. Please log in again.");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
